// @flow
import React from 'react';

import ProductHeader from './header/ProductHeaderComponent';
import ProductTypeSelect from './type-select/ProductTypeSelectComponent';
import Toolbar from './toolbar/ToolbarComponent';

import * as productTypeService from '../services/product-type/ProductTypeService';

import './ProductsPage.scss';

/**
 * The complete Products page
 */

class ProductsPageComponent extends React.Component {
  constructor(): void {
    super();
    this.state = {
      isVisible: true,
    };
    this.raf = null;
    this.callback = this.cycle.bind(this);
  }

  componentDidMount(): void {
    // eslint-disable-next-line compat/compat
    this.scroll = window.scrollY || window.pageYOffset; // Not supported in IE11
    this.raf = window.requestAnimationFrame(this.callback);
    this.props.actions.toggleNotification(1);
  }

  componentWillUnmount(): void {
    window.cancelAnimationFrame(this.raf);
    this.props.actions.toggleNotification(-1);
  }

  changeVisibilityOnScroll(): void {
    // eslint-disable-next-line compat/compat
    const scrollDiff = this.scroll - (window.scrollY || window.pageYOffset); // Not supported in IE11

    if (scrollDiff !== 0) {
      const isVisible = this.scroll < 90 || scrollDiff > 0;

      if (this.state.isVisible !== isVisible) {
        this.setState({ isVisible });
      }
    }
  }

  cycle(): void {
    this.changeVisibilityOnScroll();
    this.scroll = window.scrollY || window.pageYOffset; // eslint-disable-line compat/compat
    this.raf = window.requestAnimationFrame(this.callback);
  }

  render(): Element {
    const { config, actions, productTypeId } = this.props;
    const enableToolbar = this.props.total > 0 || productTypeService.isFilterApplied(this.props);

    return (
      <div className="products-page-component">
        <ProductHeader isVisible={this.state.isVisible} mode={enableToolbar ? 'default' : 'thin'}>
          <ProductTypeSelect config={config} actions={actions} productTypeId={productTypeId} />

          {enableToolbar && (
            <Toolbar
              totalItemCount={this.props.total}
              isVisible={this.state.isVisible}
              permissions={config.permissions}
              {...this.props}
            />
          )}
        </ProductHeader>
        {this.props.children}
      </div>
    );
  }
}

ProductsPageComponent.displayName = 'ProductsPage';

export default ProductsPageComponent;
